import React from 'react';

export default function SurveyTypeBadge({survey}) {
  return (
    <span className={`px-1 py-1 border text-white shadow-sm text-xs font-bold rounded-lg bg-blue-600 border-blue-800`}>{survey.survey_type}</span>
  )
}
